'use strict';

/**
 * @author Maxim Seredkin
 */
import angular from 'angular';
import ProjectWorkPlaceModalCreate from './controller/workPlaceModalCreate';
import ProjectWorkPlaceTableDirective from './directive/projectWorkPlaceTable';

export default angular.module('investmentProject.project.workPlace', [])
                      .controller('ProjectWorkPlaceModalCreateController', ProjectWorkPlaceModalCreate)
                      .directive('projectWorkPlaceTable', ProjectWorkPlaceTableDirective)
                      .name;
